/**
 * X Header
 */

/**
 * Init X dropdown-menus
 */
 var dropdown_menus = document.querySelectorAll('.js-x-navigation');
 for (var i = 0; i < dropdown_menus.length; i++) {
   component_dropdown_menu({
     desktop_min_width: 99999,
     menu: dropdown_menus[i]
   });
 }

/**
 * X Mobile menu
 */
 component_mobile_menu({
  menu:     document.querySelector('.js-x-mobile-menu'),
  site:     document.querySelector('.js-page'),
  toggles:  document.querySelectorAll('.js-x-menu-toggle'),
  header:   document.querySelector('.x-site-header')
});
